import { Box, ButtonIcon, IconClose } from '@acv/clearcar-component-lib';

export const ModalClose = ({ onClose }) => (
  <Box justify="flex-end" marginLeft="auto">
    <ButtonIcon onClick={onClose}>
      <IconClose />
    </ButtonIcon>
  </Box>
);
